import { useContext } from 'react'

import { NotificationsContext } from '@/contexts'

export const useNotifications = () => useContext(NotificationsContext)
